var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications-list-block"},_vm._l((_vm.list),function(log,i){return _c('Notification',{key:log.id,class:{ 'large-pc': _vm.large },attrs:{"log":log,"badgeNew":!i,"large":_vm.large,"in-modal":_vm.inModal}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }